import { Link } from "react-router-dom"
import Seo from "@/components/Seo"
import { NitaBadge } from "@/components/NitaBadge"
const teamPhoto = "/images/image.png";
const headshot = "/images/image-1.png";

const officeImg =
  "/website-assets/images/photo-1606857521015-7f9fcf423740-900x600.jpg"
const meetingImg =
  "/website-assets/images/photo-1629904853716-f0bc54eea481-900x600.jpg"

const MILESTONES = [
  {
    year: "2009",
    title: "Founded in Calgary",
    desc: "Jero-One Technologies started in Calgary, Alberta, Canada, providing IT support and technology solutions to growing businesses.",
  },
  {
    year: "2016",
    title: "East Africa Expansion",
    desc: "Expanded operations to Kenya, Tanzania, Rwanda, and beyond — serving multinational clients across the region.",
  },
  {
    year: "2019",
    title: "Moved to Minnesota",
    desc: "Relocated the company headquarters from Calgary, Alberta, to Minnesota, USA, anchoring our international presence and expanding access to North American enterprise markets.",
  },
  {
    year: "2021",
    title: "Canada Franchise Launched",
    desc: "Opened Canadian franchise operations, extending our footprint into North America's second-largest economy.",
  },
  {
    year: "2024",
    title: "500+ Projects Milestone",
    desc: "Celebrated delivery of over 500 successful enterprise IT projects across three continents.",
  },
  {
    year: "2026",
    title: "Global IT Leader",
    desc: "Recognized as one of the fastest-growing IT solutions providers bridging Africa, North America, and beyond.",
  },
]

const VALUES = [
  {
    icon: "🎯",
    title: "Excellence",
    desc: "We hold ourselves to the highest technical and professional standards on every engagement.",
  },
  {
    icon: "🌍",
    title: "Global Perspective",
    desc: "Our multi-continental presence gives us unique insight into diverse technology landscapes.",
  },
  {
    icon: "🤝",
    title: "Partnership",
    desc: "We build long-term relationships, not one-off transactions. Your success is our success.",
  },
  {
    icon: "💡",
    title: "Innovation",
    desc: "We stay ahead of the technology curve so our clients always benefit from what is next.",
  },
  {
    icon: "🔒",
    title: "Integrity",
    desc: "Transparent pricing, honest advice, and ethical business practices — always.",
  },
  {
    icon: "🚀",
    title: "Impact",
    desc: "We believe technology should drive real, measurable improvement for people and organizations.",
  },
]

// Team photos use real company images where available

export function About() {
  return (
    <div style={{ fontFamily: "'Barlow', sans-serif" }}>
      <Seo title="About Jero-One Technologies | IT Company Since 2009" description="Founded in Calgary in 2009, headquartered in Minnesota and serving Uganda since 2016. Learn about the Jero-One team, mission and track record." path="/about" />
      {/* Hero */}
      <section className="grid md:grid-cols-2 min-h-[60vh]">
        <div className="bg-[#0A0F0B] flex flex-col justify-center px-8 md:px-16 py-16">
          <div className="text-xs text-[#1B5E35] font-mono tracking-widest mb-4">
            OUR STORY
          </div>
          <h1
            className="text-6xl font-black text-[#F4F6F0] leading-none mb-6"
            style={{ fontFamily: "'Barlow Condensed', sans-serif" }}
          >
            FROM CALGARY
            <br />
            TO THE WORLD.
          </h1>
          <p className="text-[#6B7C6E] leading-relaxed max-w-md mb-6">
            What started as an IT solutions business in Calgary, Alberta,
            Canada, later moved its headquarters to Minnesota, USA, and has
            grown into a global technology company with franchise offices in
            Uganda and Canada — united by a single mission.
          </p>
          <div className="inline-flex items-center gap-3 bg-[#111A14] border border-[#1B5E35]/20 rounded-xl px-5 py-3 self-start">
            <span className="text-xl">🏆</span>
            <span className="text-[#F4F6F0] text-sm font-semibold">
              #1 IT Solutions Company — Uganda & East Africa
            </span>
          </div>
          <NitaBadge className="mt-3 self-start" />
        </div>
        <div className="relative bg-[#111A14] overflow-hidden min-h-64">
          <img fetchPriority="high"
            src={teamPhoto}
            alt="Jero-One Technologies team"
            className="w-full h-full object-cover opacity-85"
          />
          <div
            className="absolute inset-0"
            style={{
              background:
                "linear-gradient(to right, #0A0F0B 0%, transparent 20%)",
            }}
          />
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="py-20 px-6 md:px-14 bg-[#111A14]">
        <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-8">
          <div className="bg-[#0A0F0B] border border-[#1B5E35]/20 rounded-2xl p-10">
            <div className="text-3xl mb-4">🎯</div>
            <div className="text-xs text-[#1B5E35] font-mono tracking-widest mb-3">
              OUR MISSION
            </div>
            <h2
              className="text-3xl font-black text-[#F4F6F0] mb-4"
              style={{ fontFamily: "'Barlow Condensed', sans-serif" }}
            >
              BRIDGING THE DIGITAL DIVIDE
            </h2>
            <p className="text-[#6B7C6E] leading-relaxed">
              To deliver world-class IT solutions that empower businesses and
              institutions on every continent — making enterprise-grade
              technology accessible, reliable, and transformative regardless of
              geography or scale.
            </p>
          </div>
          <div className="bg-[#1B5E35] rounded-2xl p-10">
            <div className="text-3xl mb-4">🔭</div>
            <div className="text-xs text-[#F4F6F0]/60 font-mono tracking-widest mb-3">
              OUR VISION
            </div>
            <h2
              className="text-3xl font-black text-[#F4F6F0] mb-4"
              style={{ fontFamily: "'Barlow Condensed', sans-serif" }}
            >
              THE GLOBAL TECHNOLOGY PARTNER OF CHOICE
            </h2>
            <p className="text-[#F4F6F0]/75 leading-relaxed">
              To be the most trusted IT solutions provider connecting Africa,
              North America, and beyond — known for technical excellence,
              ethical practice, and genuine partnership with every client we
              serve.
            </p>
          </div>
        </div>
      </section>

      {/* Timeline */}
      <section className="py-20 px-6 md:px-14 bg-[#0A0F0B]">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-16">
            <div className="text-xs text-[#1B5E35] font-mono tracking-widest mb-3">
              OUR JOURNEY
            </div>
            <h2
              className="text-5xl font-black text-[#F4F6F0]"
              style={{ fontFamily: "'Barlow Condensed', sans-serif" }}
            >
              17 YEARS OF GROWTH
            </h2>
          </div>
          <div className="relative">
            <div className="absolute left-16 top-0 bottom-0 w-px bg-[#1B5E35]/20 hidden md:block" />
            <div className="space-y-8">
              {MILESTONES.map((m, i) => (
                <div
                  key={i}
                  className="grid md:grid-cols-[120px_1fr] gap-6 items-start"
                >
                  <div className="flex items-center gap-4">
                    <div className="w-3 h-3 rounded-full bg-[#1B5E35] flex-shrink-0 relative z-10 hidden md:block" />
                    <div
                      className="font-black text-[#1B5E35] text-lg"
                      style={{ fontFamily: "'Barlow Condensed', sans-serif" }}
                    >
                      {m.year}
                    </div>
                  </div>
                  <div className="bg-[#111A14] border border-[#1B5E35]/10 rounded-xl p-6 hover:border-[#1B5E35]/40 transition-colors">
                    <div className="font-bold text-[#F4F6F0] mb-2">
                      {m.title}
                    </div>
                    <p className="text-[#6B7C6E] text-sm leading-relaxed">
                      {m.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-20 px-6 md:px-14 bg-[#111A14]">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-14">
            <div className="text-xs text-[#1B5E35] font-mono tracking-widest mb-3">
              WHAT WE STAND FOR
            </div>
            <h2
              className="text-5xl font-black text-[#F4F6F0]"
              style={{ fontFamily: "'Barlow Condensed', sans-serif" }}
            >
              OUR CORE VALUES
            </h2>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {VALUES.map((v, i) => (
              <div
                key={i}
                className="bg-[#0A0F0B] border border-[#1B5E35]/10 rounded-2xl p-7 hover:border-[#1B5E35]/40 hover:bg-[#0A0F0B] transition-all group"
              >
                <div className="text-3xl mb-4">{v.icon}</div>
                <h3 className="font-bold text-[#F4F6F0] text-lg mb-2 group-hover:text-[#2A7D4A] transition-colors">
                  {v.title}
                </h3>
                <p className="text-[#6B7C6E] text-sm leading-relaxed">
                  {v.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Meet the Team */}
      <section className="py-20 px-6 md:px-14 bg-[#0A0F0B]">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-14">
            <div className="text-xs text-[#1B5E35] font-mono tracking-widest mb-3">
              THE PEOPLE BEHIND THE WORK
            </div>
            <h2
              className="text-5xl font-black text-[#F4F6F0]"
              style={{ fontFamily: "'Barlow Condensed', sans-serif" }}
            >
              MEET OUR TEAM
            </h2>
          </div>
          <div className="grid md:grid-cols-2 gap-8 items-start">
            {/* Group photo */}
            <div className="rounded-2xl overflow-hidden border border-[#1B5E35]/20 relative">
              <img loading="lazy" decoding="async"
                src={teamPhoto}
                alt="Jero-One Technologies team collaboration"
                className="w-full object-cover"
                style={{ maxHeight: 420 }}
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-[#0A0F0B] to-transparent px-6 py-5">
                <div className="text-[#F4F6F0] font-bold text-sm">
                  Our Team in Action
                </div>
                <div className="text-[#6B7C6E] text-xs mt-0.5">
                  Collaboration across borders
                </div>
              </div>
            </div>
            {/* Right side: headshot + two stock placeholders */}
            <div className="flex flex-col gap-6">
              {/* Featured headshot */}
              <div className="grid grid-cols-[auto_1fr] gap-5 bg-[#111A14] border border-[#1B5E35]/20 rounded-2xl p-5 items-center hover:border-[#1B5E35]/50 transition-colors">
                <img loading="lazy" decoding="async"
                  src={headshot}
                  alt="Team member"
                  className="w-24 h-24 object-cover rounded-xl flex-shrink-0"
                />
                <div>
                  <div
                    className="font-black text-[#F4F6F0] text-lg"
                    style={{ fontFamily: "'Barlow Condensed', sans-serif" }}
                  >
                    JEROME GERALD
                  </div>
                  <div className="text-[#1B5E35] text-sm font-semibold mb-1">
                    Founder & CEO
                  </div>
                  <div className="text-xs text-[#6B7C6E] font-mono tracking-wider">
                    🇺🇸 Minnesota, USA
                  </div>
                  <p className="text-[#6B7C6E] text-xs mt-2 leading-relaxed">
                    Visionary leader bridging East Africa and North America
                    through enterprise technology.
                  </p>
                </div>
              </div>
              {/* Lady in black from group photo */}
              <div className="grid grid-cols-[auto_1fr] gap-5 bg-[#111A14] border border-[#1B5E35]/20 rounded-2xl p-5 items-center hover:border-[#1B5E35]/50 transition-colors">
                <div className="w-24 h-24 rounded-xl overflow-hidden flex-shrink-0 bg-[#1B5E35]/10">
                  <img loading="lazy" decoding="async"
                    src={teamPhoto}
                    alt="Team member"
                    className="w-full h-full object-cover object-left scale-150 origin-top-left"
                  />
                </div>
                <div>
                  <div
                    className="font-black text-[#F4F6F0] text-lg"
                    style={{ fontFamily: "'Barlow Condensed', sans-serif" }}
                  >
                    JONATHAN SSEKALEGA
                  </div>
                  <div className="text-[#1B5E35] text-sm font-semibold mb-1">
                    Director, Uganda Operations
                  </div>
                  <div className="text-xs text-[#6B7C6E] font-mono tracking-wider">
                    🇺🇬 Kampala, Uganda
                  </div>
                  <p className="text-[#6B7C6E] text-xs mt-2 leading-relaxed">
                    Leading East African operations with over 10 years of
                    regional IT deployment experience.
                  </p>
                </div>
              </div>
              <div className="text-center py-4">
                <Link
                  to="/contact"
                  className="text-sm text-[#2A7D4A] font-semibold hover:underline"
                >
                  Join Our Team — We're Hiring →
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="bg-[#1B5E35] py-16 px-6 md:px-14">
        <div className="max-w-4xl mx-auto text-center">
          <h2
            className="text-5xl font-black text-[#F4F6F0] mb-4"
            style={{ fontFamily: "'Barlow Condensed', sans-serif" }}
          >
            LET'S BUILD SOMETHING GREAT TOGETHER
          </h2>
          <p className="text-[#F4F6F0]/70 mb-8">
            Whether you're in Minneapolis, Kampala, or Toronto — we're ready to
            help.
          </p>
          <div className="flex flex-wrap gap-4 justify-center">
            <Link
              to="/contact"
              className="bg-[#F4F6F0] text-[#1B5E35] font-bold px-10 py-4 rounded-xl hover:bg-white transition-colors"
            >
              Get in Touch
            </Link>
            <Link
              to="/locations"
              className="border border-[#F4F6F0]/40 text-[#F4F6F0] font-semibold px-10 py-4 rounded-xl hover:border-[#F4F6F0] transition-colors"
            >
              Find Our Offices
            </Link>
          </div>
        </div>
      </section>
    </div>
  )
}
